<script>
import loginForm from "@/components/loginForm";
export default {
  name: "login",
  components: {
    loginForm,
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {},
  mounted: function() {},
};
</script>

<template>
  <div>
    <login-form></login-form>
  </div>
</template>

<style scoped></style>
